import { useState, type ImgHTMLAttributes, type ReactNode } from "react";
import { resolveCanonicalAssetUrl, type CanonicalAssetId } from "./canonical-assets";

type CanonicalAssetImageProps = Omit<ImgHTMLAttributes<HTMLImageElement>, "alt" | "src"> & {
  id: CanonicalAssetId;
  alt?: string;
  decorative?: boolean;
  fallback?: ReactNode;
  baseUrl?: string;
};

export function CanonicalAssetImage({
  id,
  alt,
  decorative = false,
  fallback = null,
  baseUrl,
  onError,
  ...props
}: CanonicalAssetImageProps) {
  const src = resolveCanonicalAssetUrl(id, baseUrl);
  const [failedSource, setFailedSource] = useState<string>();
  if (!src || failedSource === src) return fallback;
  if (!decorative && !alt) throw new Error(`Canonical asset ${id} requires alternative text.`);
  return (
    <img
      {...props}
      src={src}
      alt={decorative ? "" : alt}
      aria-hidden={decorative || undefined}
      data-canonical-asset-id={id}
      onError={(event) => {
        setFailedSource(src);
        onError?.(event);
      }}
    />
  );
}
